import { render } from "./UploadProgressBar.vue?vue&type=template&id=f4053d70&scoped=true&ts=true"
import script from "./UploadProgressBar.vue?vue&type=script&lang=ts"
export * from "./UploadProgressBar.vue?vue&type=script&lang=ts"

import "./UploadProgressBar.vue?vue&type=style&index=0&id=f4053d70&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4053d70"]])

export default __exports__